import axios from "axios";

// This is the place where you connect to the backend which talks to light reach...

const ppaUrl = `https://dev.iondeveloper.com/api/proposal/light-reach/light-reach.php/?api_key=${process.env.REACT_APP_API_KEY}`;
const apiUrl = `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`;

const listOfStates = require("us-state-converter");

export const createAcct = async (
  {
    projectID,
    name,
    street,
    city,
    state,
    zip,
    phone,
    email,
    salesRep,
    lightReachAccountId,
    lightReachQuoteId,
    lightReachRepId,
  },
  production,
  systemSize,
  modCount,
  modMake,
  modSize,
  invMake,
  invModel,
  utilityLseId,
  productId,
  msp,
  reRoof,
  battery,
  batteryAmount,
  programType = "solar"
) => {
  const [firstName, lastName] = name.split(" ");
  console.log(lightReachRepId);
  let applicant = {
    externalReference: projectID,
    friendlyName: name,
    address: {
      address1: street,
      city: city,
      state: listOfStates.abbr(state),
      zip: zip,
    },
    applicants: [
      {
        id: "string",
        type: "primary",
        firstName: firstName,
        lastName: lastName,
        middleName: "",
        phoneNumber: phone,
        email: email,
        address: {
          address1: street,
          city: city,
          state: listOfStates.abbr(state),
          zip: zip,
        },
      },
    ],
    coordinates: {
      lat: 0,
      lon: 0,
    },
    language: "English",
    utility: {
      lseId: utilityLseId,
    },
    systemDetails: {
      systemFirstYearProductionKwh: +production,
      systemSizeKw: +systemSize / 1000,
      inverterManufacturer: invMake,
      inverterModel: invModel,
      inverterCount: modCount,
      panelManufacturer: modMake,
      panelModel: modSize,
      panelCount: modCount,
      mountingManufacturer: "string",
      mountingModel: "string",
      mountingCount: 0,
      storageManufacturer: "string",
      storageModel: "string",
      storageCount: 0,
    },
    programType,
    salesRepName: salesRep,
    salesRepLicenseNumber: lightReachRepId || "",
    permitSubmittedDate: {
      additionalProp1: {},
    },
    permitApprovedDate: {
      additionalProp1: {},
    },
    installScheduledDate: {
      additionalProp1: {},
    },
  };
  try {
    let res;
    if (lightReachAccountId) {
      res = await updateLrAcct(lightReachAccountId, applicant);
      console.log(res);
    } else {
      res = await createLrAcct(applicant);
      console.log(res);
      addLightReachAcct(projectID, res.id);
    }
    // getLightReachPricing(res.id)
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const createLrAcct = async (applicant) => {
  try {
    const res = await axios.post(ppaUrl, {
      method: "createAcct",
      applicant: JSON.stringify(applicant),
    });
    console.log(res.data);
    return res.data;
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};

const updateLrAcct = async (lightReachAccountId, applicant) => {
  try {
    const res = await axios.post(ppaUrl, {
      method: "updateAcct",
      acctId: lightReachAccountId,
      applicant: JSON.stringify(applicant),
    });
    console.log(res.data);
    return res.data;
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};

export const addLightReachAcct = async (projectID, acctId) => {
  try {
    const res = await axios.post(apiUrl, {
      method: "add_light_reach_acct",
      project_id: projectID,
      account_id: acctId,
    });
    // console.log(res.data)
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateLightReachAcct = async (acctId, productId, quoteId) => {
  try {
    const res = await axios.post(apiUrl, {
      method: "update_light_reach_acct",
      account_id: acctId,
      product_id: productId,
      quote_id: quoteId,
    });
    // console.log(res.data)
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const lightReachPricing = async (acctId, loans, msp, reRoof) => {
  try {
    const res = await axios.post(ppaUrl, {
      method: "getLightReachPricing",
      account_id: acctId,
      msp: +msp > 0 ? "true" : "false",
    });
    // console.log(msp, res.data);

    if (+reRoof > 0) {
      // console.log("No matching data available as res2.data is empty and MSP is greater than 0.");
      return loans.map((loan) => ({ ...loan, productId: "", ppwRate: "" }));
    }

    const updatedLoans = loans.map((loan) => {
      try {
        const matchingData = res?.data?.find(
          (data) =>
            +data.kwhRate === +loan.ppaRate &&
            +data.escalationRate === +loan.ppaEscalator
        );
        // console.log(matchingData);
        if (matchingData) {
          return {
            ...loan,
            productId: matchingData.productId,
            ppwRate: matchingData.ppwRate,
            ppaRate: matchingData.kwhRate,
            dealerFee: 1.0,
          };
        } else {
          return { ...loan, productId: "", ppwRate: "" };
        }
      } catch (error) {
        console.error(error);
        return { ...loan, productId: "", ppwRate: "" };
      }
    });

    // console.log('updatedLoans', updatedLoans);
    return updatedLoans;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createQuote = async (
  acctId,
  productId,
  msp,
  reRoof,
  battery,
  batteryAmount,
  arbitrageBatteryIncluded=false,
  sfProjectId="string",
) => {
  let quote = {
    productId: productId,
    externalReference: sfProjectId,
    arbitrageBatteryIncluded: false,
    backupBatteryIncluded: battery > 0 ? true : false,
    electricalUpgradeIncluded: msp > 0 ? true : false,
    roofUpgradeIncluded: false,
    backupBatteryCost: batteryAmount,
    backupBatteryManufacturer: "Tesla",
    backupBatteryModelNumber: "Powerwall 3",
    backupBatteryQuantity: battery > 0 ? battery - 10 : 0,
  };
  try {
    const res = await axios.post(ppaUrl, {
      method: "createQuoteV2",
      acctId: acctId,
      quote: JSON.stringify(quote),
    });
    // console.log(res.data, quote);
    await updateLightReachAcct(
      res.data.accountId,
      res.data.productId,
      res.data.id
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const voidQuote = async (acctId, quoteId) => {
  // console.log(acctId, quoteId)
  try {
    const res = await axios.post(ppaUrl, {
      method: "voidQuoteV2",
      acctId: acctId,
      quoteId: quoteId,
    });
    // console.log(res.data);
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
